import { AppInsightsService } from './../services/app-insights.service';
import { ToastrService } from 'ngx-toastr';
import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(error: Error | HttpErrorResponse) {

    const insights = this.injector.get(AppInsightsService);

    if (error instanceof HttpErrorResponse) {
      console.error(`HTTP ${error.status} Error: ${ error.message} (${error.url})\n See Network Tab for more info.`, '\n', error);

      // Break if HTTP Error and calling the Audits API
      if (error.url.includes('Audits/api/Audits')) {
        return;
      }

    } else {
      console.error(`ERROR: ${error.name} - ${error.message}`, '\n', error.stack, '\n', error);
    }


    insights.logException({
      error,
      severityLevel: SeverityLevel.Error
    });

  }

}
